import { render, staticRenderFns } from "./empContract.vue?vue&type=template&id=c87957c8"
import script from "./empContract.vue?vue&type=script&lang=js"
export * from "./empContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports